import {
  FacebookOutlined,
  GoogleOutlined,
  InstagramOutlined,
  TwitterOutlined,
} from "@ant-design/icons";
import Icon18Plus from "assets/icons/logo-18plus.svg";
import LogoFooter from "assets/images/logo.png";
import {
  LINK_GAME,
  LINK_INFO,
  LINK_PROMOTIONS,
  LINK_TIPS,
} from "contants/link-footer";
import { Link } from "react-router-dom";
import { ContainerFluid } from "styles/helper";

import StyledFooter from "./index.style";
const Footer = () => {
  return (
    <StyledFooter>
      <ContainerFluid>
        <div className="footer__layout">
          <div className="footer__title">
            <img
              style={{ width: "240px" }}
              className="footer__title-logo"
              src={LogoFooter}
              alt=""
            />
          </div>
          <div className="footer__bottom">
            <div className="footer__bottom-wrapper">
              <div className="menu">
                <div className="title">Games</div>
                <div className="link">
                  {LINK_GAME.map((e, i) => (
                    <div key={i} className="link-item">
                      <Link to={e.link}>{e.name}</Link>
                    </div>
                  ))}
                </div>
              </div>
              <div className="menu">
                <div className="title">Useful tips</div>
                <div className="link">
                  {LINK_TIPS.map((e, i) => (
                    <div key={i} className="link-item">
                      <Link to={e.link}>{e.name}</Link>
                    </div>
                  ))}
                </div>
              </div>
              <div className="menu">
                <div className="title">Information</div>
                <div className="link">
                  {LINK_INFO.map((e, i) => (
                    <div key={i} className="link-item">
                      <Link to={e.link}>{e.name}</Link>
                    </div>
                  ))}
                </div>
              </div>
              <div className="menu">
                <div className="title">Promotions</div>
                <div className="link">
                  {LINK_PROMOTIONS.map((e, i) => (
                    <div key={i} className="link-item">
                      <Link to={e.link}>{e.name}</Link>
                    </div>
                  ))}
                </div>
              </div>
              <div className="menu">
                <div className="title">Social</div>
                <div className="link--social">
                  <Link
                    to={"https://www.facebook.com/"}
                    target="_blank"
                    className="link-item"
                  >
                    <FacebookOutlined className="icon" />
                  </Link>
                  <Link
                    to={"https://twitter.com/?lang=vi"}
                    target="_blank"
                    className="link-item"
                  >
                    <TwitterOutlined className="icon" />
                  </Link>
                  <Link
                    to={"https://www.google.com/"}
                    target="_blank"
                    className="link-item"
                  >
                    <GoogleOutlined className="icon" />
                  </Link>
                  <Link
                    to={"https://www.instagram.com/"}
                    target="_blank"
                    className="link-item"
                  >
                    <InstagramOutlined className="icon" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="footer__license">
            <div className="footer__license-item">
              <Link
                to={""}
                title="DMCA.com Protection Status"
                className="dmca-badge"
              ></Link>
              <img
                src="https://images.dmca.com/Badges/dmca-badge-w100-5x1-05.png?ID=ab2a9c9e-4888-4094-a91e-485dac905059"
                alt="DMCA.com Protection Status"
              />
              <img className="iconplus" src={Icon18Plus} alt="+18" />
            </div>
          </div>
          <div style={{}} className="footer__copyright">
            <p>
              This website is operated by RRRBETS and is not affiliated or
              connected with sports teams, event organisers, or players
              displayed on its websites and/or mobile apps or to any mobile
              brands.
            </p>
            <p>(c) RRRbet Group Limited 2023</p>
            <p>
              RRRbets is operated by RRRbet Group Limited who is licensed and
              regulated in Great Britain by the Gambling Commission under
              account number 54743.
            </p>
            <p>
              Payment on this website may either be processed by RRRbets Group
              Limited. or by its Subsidiary partner.
            </p>
          </div>
        </div>
      </ContainerFluid>
    </StyledFooter>
  );
};

export default Footer;
